import Home from "./Home";
import Detail from "./Detail"
import Error from "./Error"

export default {
    Home,
    Detail,
    Error
}